<div class="card-password">
    <div class="flex justify-between items-center">
        <h4>Enviar para compras</h4>
        <button mat-icon-button matSuffix (click)="closeModal()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
    <div [formGroup]="form">


        <div class="flex justify-around items-center w-12/12 mt-3">

            <div class="flex flex-col justify-center items-center w-4/12 gap-2">
                <mat-label>Motorista</mat-label>
                <mat-checkbox formControlName="activeDriver" (change)="fillForm()">
                </mat-checkbox>
            </div>

            <!-- Veículo -->
            <div class="flex flex-col justify-center items-center w-4/12 gap-2">
                <mat-label>Veículo</mat-label>
                <mat-checkbox formControlName="activeVehicle" (change)="fillForm()">
                </mat-checkbox>
            </div>

        </div>

    </div>

    <div class="flex justify-center gap-5 items-center mt-3 ml-2 w-12/12">
        <button mat-flat-button class="btn-tg-cancel" (click)="cancel()">
            Cancel
        </button>

        <button mat-flat-button class="btn-tg" (click)="pushDatesPurchase()" [disabled]="!toggleActive || loading">
            @if (loading) {
            <mat-spinner diameter="22" class="loading-spinner" selected-track-color="red"></mat-spinner>
            } @else {
            Enviar
            }
        </button>
    </div>
</div>